import { render, staticRenderFns } from "./fixedPriceDetails.vue?vue&type=template&id=6d573f6e&scoped=true"
import script from "./fixedPriceDetails.vue?vue&type=script&lang=ts"
export * from "./fixedPriceDetails.vue?vue&type=script&lang=ts"
import style0 from "./fixedPriceDetails.vue?vue&type=style&index=0&id=6d573f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d573f6e",
  null
  
)

export default component.exports